<template>
  <v-container fluid>
    <div class="toolbar d-flex flex-row justify-space-between align-center elevation-3 mb-3">
      <span>
        Tiktok Authorized Shop
      </span>
      <div class="d-flex">
        <v-text-field
          v-model.trim="inputSearch"
          hide-details
          label="Search"
          append-icon="mdi-magnify"
          dense
          outlined
          @keydown.enter="getItems(true)">
        </v-text-field>
      </div>
    </div>

    <v-row class="px-8">
      <v-col
        cols="12"
        class="card-container elevation-3 mb-3">
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :items-per-page="options.itemsPerPage"
          :server-items-length="total"
          :loading="loading"
          :footer-props="{'items-per-page-options': [15, 25, 50, 100]}">
          <template #[`item.code`]="{ item }">
            {{ item.code }}
          </template>
          <template #[`item.name`]="{ item }">
            {{ item.name }}
          </template>
          <template #[`item.region`]="{ item }">
            {{ item.region }}
          </template>
          <template #[`item.sellerType`]="{ item }">
            {{ item.sellerType }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TiktokProvider from '@/resources/TiktokProvider'

const TiktokService = new TiktokProvider()

export default {
  data () {
    return {
      headers: [
        {
          text: 'Code',
          value: 'code',
          sortable: false
        },
        {
          text: 'Name',
          value: 'name',
          sortable: false
        },
        {
          text: 'Region',
          value: 'region',
          sortable: false
        },
        {
          text: 'Seller Type',
          value: 'sellerType',
          sortable: false
        },
        {
          text: 'Shop ID',
          value: 'shopId',
          sortable: false,
          width: '100'
        }
      ],
      items: [],
      brandSelected: 'Production Gentlewoman',
      allBrand: ['Production Gentlewoman', 'Gentlewoman'],
      inputSearch: '',
      total: 0,
      options: {
        page: 1,
        itemsPerPage: 25,
        sortBy: ['createdAt'],
        sortDesc: [true]
      },
      loading: false
    }
  },
  watch: {
    'query.page': {
      handler () {
        this.getItems()
      },
      deep: true
    }
  },
  async mounted () {
    await this.getItems(true)
  },
  methods: {
    async getItems () {
      try {
        this.loading = true

        const { data } = await TiktokService.getAuthorizedShop({
            page: this.options.page,
            brand: this.brandSelected,
            limit: this.options.itemsPerPage,
            sortBy: this.options.sortBy[0],
            sortOrder: this.options.sortDesc[0] ? 'desc' : 'asc',
            search: this.inputSearch
          })
        this.items = data?.results || []
        this.total = data?.total || 0
      } catch (error) {
        console.error('getItems', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.toolbar {
  position: sticky;
  top: 70px;
  left: 0;
  width: 100%;
  z-index: 5;
  background-color: #fff;
  padding: 1.25rem 1.875rem;
  border-radius: 0.625rem;
}
.toolbar span {
  font-weight: bold;
  font-size: 1.25rem;
}
.card-container {
  padding: 1.25rem 1.875rem;
  background-color: #fff;
  border-radius: 0.625rem;
  margin-top: 1.25rem;
  min-height: calc(100vh - 200px);
}
.card-title {
  font-weight: bold;
  font-size: 1.35rem;
}
.paginate-container {
  padding: 0.25rem;
  background-color: #fff;
  border-radius: 1rem;
  margin-top: 0.5rem;
}
</style>

<style>
.search-box .v-input__control {
  max-width: unset !important;
  min-height: 28px !important;
  max-height: 28px !important;
}
.search-box .v-input__slot {
  max-width: unset !important;
  min-height: 28px !important;
  max-height: 28px !important;
}
</style>
